import type { Rect } from '../types/aha-editor';

export default function transformRectAgainstContainer(
  rect: Rect,
  containerRect: Rect
): Rect {
  const { top, left, width, height } = rect;
  if (!containerRect) {
    return {
      top: top + window.scrollX,
      left: left + window.scrollY,
      width,
      height,
    };
  }

  return {
    top: rect.top - containerRect.top,
    left: rect.left - containerRect.left,
    width: rect.width,
    height: rect.height,
  };
}
